"use strict";

import AssignmentService from "./AssignmentService";

export var assignmentService = new AssignmentService();